import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  BaseShiftIconsEnum,
  BaseStaffRequestFormDatesInterface,
  ShiftsAndPersonsFormInterface,
  WeekdaysArray,
} from 'base';

@Component({
  selector: 'base-customer-weekdays-and-shifts',
  templateUrl: './base-customer-weekdays-and-shifts.component.html',
})
export class BaseCustomerWeekdaysAndShiftsComponent {
  @Input() form: FormGroup<{
    dates: FormGroup<BaseStaffRequestFormDatesInterface>;
    shiftsAndPersons: FormGroup<ShiftsAndPersonsFormInterface>;
  }>;
  @Input() submitted = false;
  @Input() flexShift = false;

  baseShiftIconsEnum = BaseShiftIconsEnum;
  shifts = Object.keys(BaseShiftIconsEnum);
  weekdaysArray = WeekdaysArray;
}
